module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.compliance) + "/" + _vm._s(_vm.missed) + " = " + _vm._s(_vm.score) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "counter-btn success"
  }, [_c('button', {
    staticClass: "btn-success plus",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.compliance++
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('br'), _vm._v("\n\t\t\tCompliance\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn-danger minus",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.complianceMinus
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "counter-btn primary"
  }, [_c('button', {
    staticClass: "btn-primary plus",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.missed++
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('br'), _vm._v("\n\t\t\tMissed Opportunity\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn-danger minus",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.missedMinus
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093a3712","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OpportunityCounterField.vue
// module id = 264
// module chunks = 0